// SYNC: crewbit-mobile/types/teamInvites.ts — keep in sync manually

export type InviteRole = 'employee' | 'contractor' | 'operator' | 'accountant';

export type InviteStatus = 'pending' | 'claimed' | 'expired' | 'revoked';

export interface TeamInvite {
  id: string;
  business_id: string;
  code: string;
  role: InviteRole;
  invited_name: string;
  invited_by: string;
  claimed_by: string | null;
  claimed_at: string | null;
  expires_at: string;
  revoked_at: string | null;
  created_at: string;
}

export interface CreateInviteResponse {
  success: boolean;
  invite_id?: string;
  code?: string;
  share_url?: string;
  error_code?: string;
}

export interface ValidateInviteResponse {
  valid: boolean;
  business_name?: string;
  role?: InviteRole;
  invited_name?: string;
  error_code?: string;
}

export interface ClaimInviteResponse {
  success: boolean;
  business_id?: string;
  business_name?: string;
  role?: InviteRole;
  user_id?: string;
  error_code?: string;
  current_business_id?: string;
}

export function deriveInviteStatus(invite: TeamInvite): InviteStatus {
  if (invite.revoked_at) return 'revoked';
  if (invite.claimed_by) return 'claimed';
  if (new Date(invite.expires_at) < new Date()) return 'expired';
  return 'pending';
}
